export const adStaticConfig = {
    adProvidersSdkLinks: {
        vli: '//nc.pubpowerplatform.io/w/4f705e57-dced-4080-8ea7-b302538a0381.js',
        epom: 'https://cdn77.aj2543.bid/3b133b93.js',
    },
    screenBannerMap: {
        HP: ['center-right_hp', 'footer_hp'],
        ResultWin: ['center_result-win', 'footer_result-win'],
        ResultLose: ['center_result-lose', 'footer_result-lose'],
        Pause: ['center_pause', 'footer_pause'],
        Gameplay: ['footer_gameplay'],
        BonusChest: ['footer_bonus-chest'],
        SkinOpened: ['footer_skin-opened'],
        Customization: ['footer_customization'],
        RewardProgress: ['footer_reward-progress'],
        DailyChallenge: ['footer_daily-challenge'],
        GoldBallOffer: ['footer_offer-gold-ball'],
        DailyBonus: ['footer_offer-daily-rewards'],
        DefaultPushOffer: ['footer_offer-push'],
        OfferStatus: ['footer_offer-status'],
        EnergyCocktail: ['footer_energy-cocktail'],
        DailyBooster: null,
        StarterBonus: null,
        LoadingScreen: null,
        Settings: null,
        Offer: null,
        GO: null,
        None: null,
    },
};

export const adDefaultMap = {
    bannerProviders: ['vli', 'epom'],
    rewardProviders: ['vli'],
    sideBanners: {
        'left-narrow': 'empty',
        'left-wide': 'empty',
        'right-narrow': 'empty',
        'right-wide': 'empty',
    },
    banners: {
        'center-right_hp': 'epom:494a2245e23b596b356881d5ea0e63bf',
        'center_pause': 'vli:pw_46999,vli:pw_46817,vli:pw_46802,vli:pw_46296',
        'center_result-win':
            'vli:pw_46997,vli:pw_46815,vli:pw_46800,vli:pw_46294', // update default ids
        'center_result-lose':
            'vli:pw_46997,vli:pw_46815,vli:pw_46800,vli:pw_46294', // update default ids
        'footer_bonus-chest':
            'vli:pw_47000,vli:pw_46818,vli:pw_46803,vli:pw_46297',
        'footer_customization':
            'vli:pw_47002,vli:pw_46820,vli:pw_46805,vli:pw_46299',
        'footer_daily-challenge':
            'vli:pw_47004,vli:pw_46822,vli:pw_46807,vli:pw_46301',
        'footer_gameplay':
            'vli:pw_46995,vli:pw_46813,vli:pw_46798,vli:pw_45963',
        'footer_hp': 'vli:pw_46994,vli:pw_46812,vli:pw_46797,vli:pw_45964',
        'footer_offer-status':
            'vli:pw_47005,vli:pw_46823,vli:pw_46808,vli:pw_46302',
        'footer_pause': 'vli:pw_46998,vli:pw_46816,vli:pw_46801,vli:pw_46295',
        'footer_result-win': 'epom:3835377c68bac521cc4869ef2e768a48', // update default ids
        'footer_result-lose': 'epom:3835377c68bac521cc4869ef2e768a48', // update default ids
        'footer_reward-progress':
            'vli:pw_47003,vli:pw_46821,vli:pw_46806,vli:pw_46300',
        'footer_skin-opened':
            'vli:pw_47001,vli:pw_46819,vli:pw_46804,vli:pw_46298',
        'footer_offer-gold-ball':
            'vli:pw_47006,vli:pw_46824,vli:pw_46809,vli:pw_46314',
        'footer_offer-push':
            'vli:pw_47007,vli:pw_46825,vli:pw_46810,vli:pw_46315',
        'footer_offer-daily-rewards':
            'vli:pw_47008,vli:pw_46826,vli:pw_46811,vli:pw_46316',
        'footer_energy-cocktail':
            'vli:pw_47248,vli:pw_47249,vli:pw_47250,vli:pw_47251',
    },
    rewards: {
        Plus500Coins: 'vli:pw_46913,vli:pw_46914,vli:pw_46915,vli:pw_46916',
        Plus100Coins: 'vli:pw_46917,vli:pw_46918,vli:pw_46919,vli:pw_46920',
        Plus1Bag: 'vli:pw_46921,vli:pw_46922,vli:pw_46923,vli:pw_46924',
        GetThirdKey: 'vli:pw_46925,vli:pw_46926,vli:pw_46927,vli:pw_46928',
        CollectAndSkipLevel:
            'vli:pw_46929,vli:pw_46930,vli:pw_46931,vli:pw_46932',
        MultiplyCoins: 'vli:pw_46933,vli:pw_46934,vli:pw_46935,vli:pw_46936',
        ExtraProgress: 'vli:pw_46937,vli:pw_46938,vli:pw_46939,vli:pw_46940',
        SkipLevel: 'vli:pw_46941,vli:pw_46942,vli:pw_46943,vli:pw_46944',
        ReplayLevel: 'vli:pw_46945,vli:pw_46946,vli:pw_46947,vli:pw_46948',
        DailyRewardX2: 'vli:pw_46961,vli:pw_46962,vli:pw_46963,vli:pw_46964',
        StarterBonus: 'vli:pw_46949,vli:pw_46950,vli:pw_46951,vli:pw_46952',
        ResBoosterReward: 'vli:pw_46953,vli:pw_46954,vli:pw_46955,vli:pw_46956',
        BattlePassStar: 'vli:pw_46957,vli:pw_46958,vli:pw_46959,vli:pw_46960',
        GetEnergyCocktail:
            'vli:pw_46965,vli:pw_46966,vli:pw_46967,vli:pw_46968',
    },
};
